import { ReportColumnConfig } from '../types';

export const generateReportHeaders = <T>(
  columns: ReportColumnConfig<T>[]
): { key: string; label: string }[] => {
  return columns.map(({ key, label }) => ({ key, label }));
};
